import {
  AccountReservationDetailsResponse,
  AttachInstantCardRequest,
  CardProgramResponse,
  ClaimLimitedAccountRequest,
  CreateWalletRequest,
  CreateWalletResponse,
  EnterLastFourOnCardResponse,
  GetAccessCodeResponse,
  GetCodeRequest,
  KycConfigResponse,
  KycStatusResponse,
  LinkKycRecordRequest,
  MarqetaOneTimeTokenResponse,
  OrgDetailsResponse,
  OrgSettingsResponse,
  PostAccessCodeRequest,
  RosterMatchResponse,
  ShippingTimeResponse,
  SignUpGetCodeRequest,
  SignUpUserRequest,
  SignUpUserResponse,
  SSOResponse,
  SsoSignInValidationResponse,
  SsoValidationResponse,
  TermsDetails,
  UserDetailsResponse,
  ValidateAccessCodeRequest,
  ValidateLoginCodeRequest,
  ValidateLoginCodeResponse,
  ValidateSSORequest,
  WhiteLabelAppInfo,
} from './api.types'
import { branchWebHttp, http } from './http'

export const getOrgDetails = (orgId: string) =>
  http.get<OrgDetailsResponse>(`/p1/organizations/${orgId}/info`)

export const getAccountReservationDetails = (
  lastFour: string,
  accountToken?: string,
  kycReferenceId?: string
) =>
  http.post<AccountReservationDetailsResponse>(
    '/p1/wallet/account/reservation',
    {
      ssn_last_four: lastFour,
      account_reference_token: accountToken || undefined,
      kyc_reference_id: kycReferenceId || undefined,
    }
  )

export const logoutUser = () => http.post('/v2/login/logout')

export const validateToken = (token: string) =>
  branchWebHttp.get<SsoValidationResponse>(`/validate?t=${token}`)

export const validateSSO = (req: ValidateSSORequest) =>
  http.post<SsoSignInValidationResponse>('/v2/login/validate-sso', req)

export const getUserWallet = () => http.get('/p1/wallet/account')

export const enterLastFourOnCard = (code: string, nameOnCard: string) =>
  http.get<EnterLastFourOnCardResponse>(
    `/p1/wallet/account/unclaimed?last4=${code}&name_on_card=${nameOnCard}`
  )

export const claimLimitedAccount = (req: ClaimLimitedAccountRequest) =>
  http.post<CreateWalletResponse>('/p1/wallet/account/reservation/kyc', req)

export const createWallet = ({
  version = 7,
  ...requestBody
}: CreateWalletRequest) =>
  http.post<CreateWalletResponse>('/p1/wallet/account/creation', requestBody, {
    params: { version, web_onboarding: true },
  })

export const attachInstantCard = (req: AttachInstantCardRequest) =>
  http.post('/p1/wallet/instant_card/attach', req)

export const validateAccessCode = (req: ValidateAccessCodeRequest) =>
  http.post('/auth/access_code/token', req)

export const getAccessCode = () =>
  http.get<GetAccessCodeResponse>('/auth/access_code')

export const postAccessCode = (req: PostAccessCodeRequest) =>
  http.post('/auth/access_code', req)

export const getLoginCode = (req: GetCodeRequest) =>
  http.post('/v2/login/get-code', req)

export const validateLoginCode = (req: ValidateLoginCodeRequest) =>
  http.post<ValidateLoginCodeResponse>('/v2/login/validate-code', req)

export const SSORequest = (orgId: string) =>
  http.get<SSOResponse>(`p1/organizations/${orgId}/single_sign_on`)

export const getKycOnboardingConfig = () =>
  http.get<KycConfigResponse>('/p1/wallet/kyc/config?web_onboarding=true')

export const signupSendCode = (req: SignUpGetCodeRequest) =>
  http.post('/v2/signup/get-code', req)

export const linkKycRecord = (req: LinkKycRecordRequest) =>
  http.post('/p1/wallet/account/reservation/link_kyc', req)

export const linkExistingUser = (userId: string, defaultLocationId: string) =>
  http.post(`/p1/users/${userId}/locations/${defaultLocationId}`, undefined)

export const getUserDetails = (userId: string) =>
  http.get<UserDetailsResponse>(`/p1/users/${userId}`)

export const getKycStatus = (inquiryId?: string) => {
  const params = inquiryId ? `?inquiry_id=${inquiryId}` : ''
  return http.get<KycStatusResponse>(`/p1/wallet/kyc/status${params}`)
}

export const getMarqetaOneTimeToken = () =>
  http.get<MarqetaOneTimeTokenResponse>(
    '/p1/wallet/marqeta/one_time_user_token'
  )

export const getShippingTime = () =>
  http.get<ShippingTimeResponse>('/p1/wallet/account/cards/shipping_time_info')

export const signUpUser = (req: SignUpUserRequest) =>
  http.post<SignUpUserResponse>('/v2/signup?version=1', req)

export const rosterMatch = (
  orgId: string,
  firstName: string,
  lastName: string,
  email?: string
) =>
  http.get<RosterMatchResponse>(
    `/p1/organizations/${orgId}/match?first_name=${firstName}&last_name=${lastName}&email_address=${encodeURIComponent(
      email || ''
    )}`
  )

export const getOrgSettings = (locationId?: string) =>
  http.get<OrgSettingsResponse>(
    `/p1/organizations/settings?location_id=${locationId}`
  )

// unauthenticated request
export const getUserTerms = () =>
  http.get<TermsDetails[]>('/p2/accounts/terms/pre_user')

export const getPremierTerms = () =>
  http.get<TermsDetails[]>('/p2/accounts/terms/post_kyc')

export const getEssentialTerms = () =>
  http.get<TermsDetails[]>('/p2/accounts/terms/paycard/post_kyc')

export const getWhiteLabelAppInfo = () =>
  http.get<WhiteLabelAppInfo>('/p2/white_label_apps/info')

export const getUserCardProgram = () =>
  http.get<CardProgramResponse>('/p2/user/card_program')
